import { AppDispatch } from 'app/store';
import { SizingItemsType } from 'data/types';
import {
  markDefaultCategoryModified,
  updateDefaultSizingItemCategory
} from 'features/data/data-slice';

export type WindowPanesOption = 'Single' | 'Double' | 'Triple';

export const VALID_WINDOW_PANES: readonly WindowPanesOption[] = [
  'Single',
  'Double',
  'Triple'
];

export const WINDOW_PANES_OPTIONS = [
  { label: 'Single', value: 'Single' },
  { label: 'Double', value: 'Double' },
  { label: 'Triple', value: 'Triple' },
  { label: 'Custom', value: 'Custom', disabled: true }
];

export const WINDOW_BUG_SCREEN_OPTIONS: string[] = ['Yes', 'No'];

export function getWindowPanesValue(
  verticalGlass: SizingItemsType['verticalGlass'] | undefined
): WindowPanesOption | 'Custom' {
  const panes = verticalGlass?.panes;
  if (panes && VALID_WINDOW_PANES.includes(panes as WindowPanesOption)) {
    return panes as WindowPanesOption;
  }
  return panes ? 'Custom' : 'Single';
}

export function getWindowBugScreenValue(
  verticalGlass: SizingItemsType['verticalGlass'] | undefined
): 'Yes' | 'No' {
  return verticalGlass?.bugScreen === 'Full Indoor' ? 'Yes' : 'No';
}

export function applyWindowPanesChange(
  dispatch: AppDispatch,
  value: string | number
): void {
  if (value === 'Custom') return;
  dispatch(
    updateDefaultSizingItemCategory({
      category: 'verticalGlass',
      updates: { panes: value as WindowPanesOption }
    })
  );
  dispatch(markDefaultCategoryModified('fenestration'));
}

export function applyWindowBugScreenChange(
  dispatch: AppDispatch,
  value: string | number
): void {
  dispatch(
    updateDefaultSizingItemCategory({
      category: 'verticalGlass',
      updates: { bugScreen: value === 'Yes' ? 'Full Indoor' : 'None' }
    })
  );
  dispatch(markDefaultCategoryModified('fenestration'));
}
